import { Avatar, Form, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import CustomButton from '../../../Components/CustomButton'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RouterKeys } from '../../../Routes/RouterKeys'
import Loader from '../../../Components/Loader'

function MyProfile() {

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const FileUrl = process.env.REACT_APP_FILE_URL
    const adminData = useSelector((state) => state?.auth?.auth_data)
    const adminFirstName = useSelector((state) => state?.auth?.auth_data?.first_name)
    const adminLastName = useSelector((state) => state?.auth?.auth_data?.last_name)
    const adminEmail = useSelector((state) => state?.auth?.auth_data?.email)
    const adminPic = useSelector((state) => state?.auth?.auth_data?.profile_pic)


    const [isDataLoaded, setIsDataLoaded] = useState(false);


    useEffect(() => {
        // Check if the necessary data has loaded from redux
        if (adminFirstName && adminLastName && adminEmail) {
            setIsDataLoaded(true); // Mark data as loaded
        }
    }, [adminFirstName, adminLastName, adminEmail]);

    useEffect(() => {
        if (isDataLoaded) {
            // Set the form values when the data is loaded
            form.setFieldsValue({
                firstName: adminFirstName,
                lastName: adminLastName,
                email: adminEmail,
            });
        }
    }, [isDataLoaded, adminFirstName, adminLastName, adminEmail, form]);


    const handleEditProfileClick = () => {
        navigate(RouterKeys.NON_Auth.EDIT_PROFILE);
    }
    if (!isDataLoaded) {
        return <Loader />;
    }


    return (
        <>
            <p className="text-h3 font-bold">Profile</p>
            <div className='rounded-lg shadow-cardCustom w-full md:w-1/2 my-4'>
                <Form
                    form={form}
                    className="p-5"
                    layout="vertical"
                    autoComplete="off"
                    requiredMark={false}
                >
                    <Form.Item
                        name="profilePic"
                    >
                        <Avatar
                            size={150}
                            src={`${FileUrl}${adminPic}`}
                            alt="Admin Pic"
                        />
                    </Form.Item>
                    <Form.Item
                        label={<p className='auth_input_label'>FirstName</p>}
                        name="firstName"
                    >
                        <Input
                            size='large'
                            className='auth_input_ss'
                            value={adminFirstName}
                            readOnly
                        />
                    </Form.Item>
                    <Form.Item
                        label={<p className='auth_input_label'>LastName</p>}
                        name="lastName"
                    >
                        <Input
                            size='large'
                            className='auth_input_ss'
                            value={adminLastName}
                            readOnly
                        />
                    </Form.Item>
                    <Form.Item
                        label={<p className='auth_input_label'>Email</p>}
                        name="email"
                    >
                        <Input
                            size='large'
                            className='auth_input_ss'
                            value={adminEmail}
                            readOnly
                        />
                    </Form.Item>
                    <Form.Item >
                        <div className='flex gap-4'>
                            <CustomButton
                                title='Edit Profile'
                                className="commonButton mt-12 w-fit text-center"
                                onClick={handleEditProfileClick}
                            />
                            <CustomButton
                                title='Change Password'
                                className="commonButton mt-12 w-fit text-center"
                                onClick={(e) => { navigate(RouterKeys.NON_Auth.CHANGE_PASSWORD); }}
                            />
                        </div>

                    </Form.Item>
                </Form>
            </div>
        </>
    )
}

export default MyProfile